var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar",style:({
    height: _vm.size + 'px',
    width: _vm.size + 'px',
    minWidth: _vm.size + 'px',
  })},[_c('div',{staticClass:"image-wrapper",class:{stroke: _vm.stroke},style:({
    fontSize: _vm.size / 3 + 'px'
  })},[(_vm.user.avatar)?_c('img',{attrs:{"src":_vm.user.avatar,"alt":"avatar"}}):_c('span',[_vm._v(_vm._s(_vm.initials))])]),(_vm.user.isOnline && _vm.showStatus)?_c('span',{staticClass:"status bg-success"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }